import React from 'react';

function TermsOfService() {
  return (
    <div className="prose max-w-none">
      <p className="text-lg font-semibold mb-6">시행일자: 2025년 8월 1일</p>

      <h3 className="text-xl font-bold mb-4">1. 서비스 소개</h3>
      
      <h4 className="text-lg font-semibold mb-3">🎯 서비스 목적</h4>
      <p className="mb-4">
        면접톡 면접 연습 서비스(이하 "본 서비스")는 취업 준비생들이 효과적으로 면접을 연습할 수 있도록 지원하는 무료 서비스입니다.
      </p>

      <h4 className="text-lg font-semibold mb-3">🔧 제공 기능</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>기본질문, 심화질문, 상황질문, 직무질문 제공</li>
        <li>음성 인식 기반 답변 연습</li>
        <li>TTS(Text-to-Speech) 질문 읽기</li>
        <li>답변 시간 관리 및 연습 환경 제공</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">2. 서비스 이용</h3>
      
      <h4 className="text-lg font-semibold mb-3">✅ 이용 조건</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>누구나 무료로 이용 가능</li>
        <li>별도의 회원가입 불필요</li>
        <li>인터넷 연결 및 마이크 사용 권한 필요</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">🎤 음성 기능 이용</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>브라우저의 음성 인식 기능 사용</li>
        <li>마이크 접근 권한 허용 필요</li>
        <li>음성 데이터는 저장되지 않음</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">📱 지원 환경</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>Chrome, Safari, Edge 등 주요 브라우저</li>
        <li>PC, 태블릿, 스마트폰 지원</li>
        <li>안정적인 인터넷 연결 권장</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">3. 이용자의 의무</h3>
      
      <h4 className="text-lg font-semibold mb-3">✅ 올바른 이용</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>면접 연습 목적으로만 사용</li>
        <li>다른 이용자에게 피해를 주지 않을 것</li>
        <li>서비스의 정상적인 운영을 방해하지 않을 것</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">🚫 금지 행위</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>시스템 해킹 또는 악용 시도</li>
        <li>불법적이거나 부적절한 내용 입력</li>
        <li>서비스의 무단 복제 또는 상업적 이용</li>
        <li>자동화 프로그램을 통한 무분별한 접속</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">4. 서비스 제공 및 변경</h3>
      
      <h4 className="text-lg font-semibold mb-3">🔄 서비스 운영</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>24시간 서비스 제공을 원칙으로 함</li>
        <li>시스템 점검, 업데이트 등으로 일시 중단될 수 있음</li>
        <li>중요한 점검 시 사전 공지</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">📈 서비스 개선</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>사용자 편의를 위한 기능 추가 및 개선</li>
        <li>질문 내용 및 기능의 변경 가능</li>
        <li>주요 변경사항은 웹사이트를 통해 공지</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">5. 책임의 제한</h3>
      
      <h4 className="text-lg font-semibold mb-3">⚠️ 서비스 제공자의 책임</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>고의 또는 중대한 과실이 없는 한 책임을 지지 않음</li>
        <li>천재지변, 불가항력적 사유로 인한 서비스 중단에 대해 책임지지 않음</li>
        <li>이용자의 귀책사유로 인한 손해에 대해 책임지지 않음</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">👤 이용자의 책임</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>자신의 계정 정보 및 비밀번호 관리에 대한 책임</li>
        <li>서비스 이용 중 발생한 손해에 대한 책임</li>
        <li>관련 법령 및 이용약관 준수에 대한 책임</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">6. 분쟁 해결</h3>
      
      <h4 className="text-lg font-semibold mb-3">⚖️ 준거법 및 관할</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>대한민국 법률을 준거법으로 함</li>
        <li>서비스 관련 분쟁은 대한민국 법원에서 해결</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">🤝 분쟁 조정</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>분쟁 발생 시 당사자 간 협의를 통한 해결 우선</li>
        <li>협의가 불가능한 경우 관련 법령에 따른 조정 또는 중재</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">7. 기타 사항</h3>
      
      <h4 className="text-lg font-semibold mb-3">📝 약관의 효력</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>본 약관은 서비스 이용과 동시에 효력 발생</li>
        <li>약관의 일부가 무효가 되어도 나머지 조항은 유효</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">🔄 약관의 변경</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>관련 법령 변경 또는 서비스 정책 변경에 따라 수정 가능</li>
        <li>변경 시 웹사이트를 통해 공지</li>
        <li>변경된 약관은 공지 후 즉시 또는 명시된 날짜부터 효력 발생</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">8. 연락처</h3>
      <div className="bg-blue-50 p-4 rounded-lg mb-6">
        <h4 className="text-lg font-semibold mb-3">📞 서비스 문의</h4>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>이메일</strong>: job1004jane@gmail.com</li>
          <li><strong>답변 소요시간</strong>: 영업일 기준 1~2일</li>
        </ul>
      </div>

      <div className="border-t pt-4 mt-6">
        <p className="text-center font-semibold">최종 수정일: 2025년 8월 1일</p>
        <p className="text-center text-sm text-gray-600 mt-2">
          본 이용약관은 서비스 이용 전 반드시 읽어보시기 바랍니다.
        </p>
      </div>
    </div>
  );
}

export default TermsOfService;